import { IWorkspacePermissionAccess, IWorkspaceResourceFolder, WorkspaceResourceType } from "common/interfaces";
import WorkspaceController, { getWorkspaceResources } from "js/controllers/WorkspaceController";
import getLogger, { LogGroup } from "js/core/logger";

const logger = getLogger(LogGroup.TEAMS);

const DEFAULT_PERMISSIONS: Omit<IWorkspacePermissionAccess, "owner"> = {
    read: { object: true, permissions: true },
    write: { object: false, permissions: false },
};

export type MovePermissionsByResourceType = Partial<Record<WorkspaceResourceType, Omit<IWorkspacePermissionAccess, "owner">>>;

export async function moveSubfolderContentsToParentFolder(
    folder: IWorkspaceResourceFolder,
    resourceTypes: WorkspaceResourceType[],
    permissionsByResourceType: MovePermissionsByResourceType = {}
) {
    const parentFolderId = folder.parentFolderId;
    if (!parentFolderId || resourceTypes.length === 0) {
        return;
    }

    const resources = await getWorkspaceResources({
        workspaceId: WorkspaceController.workspaceId,
        resourceTypes,
        resourceFilters: [{ field: "folderIds", operator: "eq", value: folder.id }],
    });

    if (resources.length === 0) {
        return;
    }

    try {
        await WorkspaceController.updateWorkspaceResourceFolderResources({
            folderId: parentFolderId,
            update: {
                add: resources.map(resource => ({
                    resourceId: resource.resourceId,
                    resourceType: resource.resourceType,
                    permissions: permissionsByResourceType[resource.resourceType] ?? DEFAULT_PERMISSIONS
                })),
            },
        });
    } catch (err) {
        logger.error(err, "[moveSubfolderContentsToParentFolder] failed", {
            folderId: folder.id,
            parentFolderId,
        });
        throw err;
    }
}
